import { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Checkout({ cart = [], totalPrice = 0, setCart, setPage, language = "en" }) {
  
  // Form States
  const [formData, setFormData] = useState({
    emailOrPhone: "",
    emailNews: true,
    cityDropdown: "",
    country: "Pakistan",
    firstName: "",
    lastName: "",
    address: "",
    apartment: "",
    cityInput: "",
    postalCode: "",
    phone: "",
    saveInfo: false,
    shippingMethod: "FREE",
    paymentMethod: "PAYFAST",
    billingAddress: "same",
  
  });

  const [discountCode, setDiscountCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [message, setMessage] = useState("");

const safeTotalPrice = cart.reduce((total, item) => {
  const price = Number(
    item?.price ??
    item?.mrp ??
    item?.new_price ??
    item?.sale_price ??
    0
  );

  const qty = Number(item?.qty ?? 1);

  return total + price * qty;
}, 0);

const discountedTotal =
  safeTotalPrice - (safeTotalPrice * discount) / 100;
  const text = {
    en: {
      contact: "Contact",
      signIn: "Sign in",
      emailPhone: "Email or mobile phone number",
      emailNews: "Email me with news and offers",
      delivery: "Delivery",
      selectCity: "Select city from dropdown",
      cityErrorDropdown: "Please select city from dropdown",
      cityErrorInput: "Please select city from city dropdown",
      pakistan: "Pakistan",
      firstName: "First name",
      lastName: "Last name",
      address: "Address",
      apartment: "Apartment, suite, etc. (optional)",
      city: "City",
      postalCode: "Postal code (optional)",
      phone: "Phone",
      saveInfo: "Save this information for next time",
      shipping: "Shipping method",
      homeDelivery: "HOME DELIVERY",
      free: "FREE",
      payment: "Payment",
      secure: "All transactions are secure and encrypted.",
      payfast: "PAYFAST (Pay via Debit/Credit/Wallet/Bank Account)",
      redirected: "You'll be redirected to PAYFAST to complete your purchase.",
      cod: "Cash on Delivery (COD)",
      billing: "Billing address",
      sameAddress: "Same as shipping address",
      differentAddress: "Use a different billing address",
      completeOrder: "Complete Order",
      payNow: "Pay now",
      discountCode: "Discount code",
      apply: "Apply",
      subtotal: "Subtotal",
      discount: "Discount",
      total: "Total",
      items: "items",
      cartEmpty: "Cart is empty!",
      orderPlaced: "Order placed successfully!",
      emailFailed: "Email failed",
      invalidDiscount: "Invalid discount code",
      discountApplied: "discount applied!",
      standardSize: "Standard Size",
      orderSummary: "Order Summary",
      currency: "Rs",
    },
    ur: {
      contact: "رابطہ",
      signIn: "سائن اِن",
      emailPhone: "ای میل یا موبائل نمبر",
      emailNews: "مجھے خبروں اور آفرز کی ای میل بھیجیں",
      delivery: "ڈیلیوری",
      selectCity: "شہر منتخب کریں",
      cityErrorDropdown: "براہ کرم ڈراپ ڈاؤن سے شہر منتخب کریں",
      cityErrorInput: "براہ کرم شہر کے ڈراپ ڈاؤن سے شہر منتخب کریں",
      pakistan: "پاکستان",
      firstName: "پہلا نام",
      lastName: "آخری نام",
      address: "پتہ",
      apartment: "اپارٹمنٹ، سوئٹ وغیرہ (اختیاری)",
      city: "شہر",
      postalCode: "پوسٹل کوڈ (اختیاری)",
      phone: "فون نمبر",
      saveInfo: "یہ معلومات اگلی بار کے لیے محفوظ کریں",
      shipping: "شپنگ کا طریقہ",
      homeDelivery: "گھر تک ڈیلیوری",
      free: "مفت",
      payment: "ادائیگی",
      secure: "تمام لین دین محفوظ اور خفیہ ہے۔",
      payfast: "پے فاسٹ (کارڈ، والیٹ یا بینک کے ذریعے)",
      redirected: "آپ کو ادائیگی مکمل کرنے کیلئے پے فاسٹ پر بھیجا جائے گا۔",
      cod: "کیش آن ڈیلیوری (COD)",
      billing: "بلنگ ایڈریس",
      sameAddress: "شپنگ ایڈریس جیسا",
      differentAddress: "مختلف بلنگ ایڈریس استعمال کریں",
      completeOrder: "آرڈر مکمل کریں",
      payNow: "ابھی ادائیگی کریں",
      discountCode: "ڈسکاؤنٹ کوڈ",
      apply: "لاگو کریں",
      subtotal: "ذیلی کل",
      discount: "رعایت",
      total: "کل",
      items: "آئٹمز",
      cartEmpty: "کارٹ خالی ہے!",
      orderPlaced: "آرڈر کامیابی سے جمع ہو گیا!",
      emailFailed: "ای میل بھیجنے میں مسئلہ پیش آیا",
      invalidDiscount: "غلط ڈسکاؤنٹ کوڈ",
      discountApplied: "ڈسکاؤنٹ لاگو ہوگیا!",
      standardSize: "سٹینڈرڈ سائز",
      orderSummary: "آرڈر کا خلاصہ",
      currency: "روپے",
    },
  };

  const t = text[language] || text.en;
  
  const getImage = (item)=>{

    let img =
      item.image_url ||
      item.image ||
      item.img;


    if(!img){
      return "/no-image.png";
    }


    if(img.startsWith("http")){
      return img;
    }


    return `https://onlinepk.me/admin/upload/item/${img}`;
  }

  const isUrdu = language === "ur";
     
  const promoCodes = {
    SAVE10: 10,
    SAVE20: 20,
    FLAT5: 5,
  };

  const handleApplyDiscount = () => {
    const code = discountCode.trim().toUpperCase();

    if (promoCodes[code]) {
      setDiscount(promoCodes[code]);
      setMessage(`🎉 ${promoCodes[code]}% ${t.discountApplied}`);
    } else {
      setDiscount(0);
      setMessage(`❌ ${t.invalidDiscount}`);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  if (cart.length === 0) {
    alert(t.cartEmpty);
    return;
  }

  const orderId = "ORD" + Date.now();

  const items = cart.map(item => ({
    id: item.id,
    name: item.name,
    qty: item.qty,
    price: item.price
  }));

  const templateParams = {
    order_id: orderId,
    customer_name: `${formData.firstName} ${formData.lastName}`,
    customer_email: formData.emailOrPhone,
    customer_phone: formData.phone,
    customer_address: `${formData.address}, ${formData.cityDropdown}`,
    items: items
      .map(i => `${i.name} x ${i.qty} = Rs ${i.price * i.qty}`)
      .join("\n"),
    total: discountedTotal,
  };

  try {

    // Save Order
    const response = await fetch("https://onlinepk.me/api/order", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        first_name: formData.firstName,
        last_name: formData.lastName,
        phone: formData.phone,
        email: formData.emailOrPhone,
        address: formData.address,
        city: formData.cityDropdown,
        total_amount: discountedTotal,
        items: items
      })
    });

    if (!response.ok) {
      throw new Error("Server Error");
    }

    const result = await response.json();

    console.log(result);

    // Email
    await emailjs.send(
      "service_1gfk5nb",
      "template_0xj4x9d",
      templateParams,
      "sSjphFS6l-1d0tKO8"
    );

    // WhatsApp
    const message = `
🛒 New Order

Order ID : ${orderId}

Customer : ${formData.firstName} ${formData.lastName}

Phone : ${formData.phone}

City : ${formData.cityDropdown}

Address : ${formData.address}

Total : Rs ${discountedTotal}
`;

    const phone = formData.phone.replace(/\D/g, "");

    window.open(
      `https://wa.me/92${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );

    alert("Order Placed Successfully");

    setCart([]);

    setPage("orderSuccess");

  } catch (err) {

    console.error(err);

    alert(err.message);

  }
};


const styles = {
  productRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 0",
    borderBottom: "1px solid #eee",
  },

  productLeft: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    flex: 1,
  },

  productImage: {
    width: "70px",
    height: "70px",
    objectFit: "cover",
    borderRadius: "8px",
    border: "1px solid #ddd",
    flexShrink: 0,
  },

  productName: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#222",
  },

  productSize: {
    marginTop: "5px",
    fontSize: "13px",
    color: "#777",
  },

  productPrice: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#222",
    whiteSpace: "nowrap",
    marginLeft: "20px",
  },
};

  // Common styles that don't change with language
  const commonStyles = {
    layout: {
      display: "flex",
      gap: "40px",
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "20px",
      flexDirection: "row", // Always row - form left, summary right
    },
    leftColumn: {
      flex: "1.2",
      minWidth: "0",
    },
    rightColumn: {
      flex: "0.8",
      minWidth: "300px",
    },
    section: {
      marginBottom: "30px",
      padding: "20px",
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    sectionTitle: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#333",
    },
    input: {
      width: "100%",
      padding: "10px 12px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "14px",
      marginBottom: "10px",
      transition: "border-color 0.3s",
      background: "#fff",
      boxSizing: "border-box",
    },
    inputError: {
      borderColor: "#256628",
    },
    rowInputs: {
      display: "flex",
      gap: "10px",
      marginBottom: "10px",
    },
    rowInput: {
      flex: 1,
      minWidth: "0",
    },
    checkbox: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "10px",
      cursor: "pointer",
    },
    checkboxInput: {
      width: "16px",
      height: "16px",
      cursor: "pointer",
    },
    shippingBox: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 16px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      background: "#fafafa",
    },
    paymentOption: {
      padding: "12px 16px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      marginBottom: "8px",
      cursor: "pointer",
      transition: "all 0.3s",
    },
    paymentOptionActive: {
      borderColor: "#256628",
      background: "#f0f7ff",
    },
    paymentLabel: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
    },
    paymentRadio: {
      width: "16px",
      height: "16px",
      cursor: "pointer",
    },
    paymentDesc: {
      marginTop: "8px",
      fontSize: "13px",
      color: "#666",
      paddingLeft: "24px",
    },
    submitBtn: {
      width: "100%",
      padding: "14px",
      background: "#256628",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "background 0.3s",
      marginTop: "10px",
    },
    summary: {
      position: "sticky",
      top: "20px",
    },
    summaryTitle: {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "20px",
      color: "#333",
    },
    itemRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 0",
      borderBottom: "1px solid #f0f0f0",
    },
    itemLeft: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
    },
    itemImage: {
      position: "relative",
      width: "60px",
      height: "60px",
      flexShrink: "0",
    },
   itemImg: {
  width: "70px",
  height: "70px",
  objectFit: "cover",
  borderRadius: "8px",
  border: "1px solid #ddd",
  display: "block",
},
    itemBadge: {
      position: "absolute",
      top: "-5px",
      right: "-5px",
      background: "#333",
      color: "#fff",
      borderRadius: "50%",
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "11px",
      fontWeight: "bold",
    },
    itemDetails: {
      flex: "1",
    },
    itemName: {
      fontSize: "14px",
      fontWeight: "500",
      margin: "0 0 4px 0",
    },
    itemSize: {
      fontSize: "12px",
      color: "#666",
      margin: "0",
    },
    itemPrice: {
    
      fontSize: "17px",
      fontWeight: "500",
      float:"right",
    },
    discountSection: {
      display: "flex",
      gap: "10px",
      margin: "20px 0",
    },
    discountInput: {
      flex: 1,
      padding: "8px 12px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "14px",
    },
    discountBtn: {
      padding: "8px 20px",
      background: "#256628",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontWeight: "500",
      transition: "background 0.3s",
    },
    message: {
      fontSize: "13px",
      marginTop: "-10px",
      marginBottom: "15px",
    },
    totals: {
      borderTop: "1px solid #eee",
      paddingTop: "15px",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      padding: "6px 0",
      fontSize: "14px",
    },
    totalGrand: {
      fontSize: "18px",
      fontWeight: "700",
      padding: "10px 0",
    },
    hr: {
      border: "none",
      borderTop: "1px solid #ddd",
      margin: "12px 0",
    },
    errorText: {
      fontSize: "12px",
      color: "#256628",
      display: "block",
      marginTop: "4px",
    },
    secureText: {
      fontSize: "13px",
      color: "#666",
      marginBottom: "10px",
    },
    sectionHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    loginLink: {
      cursor: "pointer",
      color: "#256628",
      fontSize: "14px",
    },
  };

  return (
    <div style={{ ...commonStyles.layout }}>
      {/* LEFT COLUMN: FORM - Always stays on left */}
      <div style={commonStyles.leftColumn}>
        <form onSubmit={handleSubmit}>
          
          {/* 1. Contact Section */}
          <div style={{ ...commonStyles.section, textAlign: isUrdu ? "right" : "left" }}>
            <div style={commonStyles.sectionHeader}>
              <h2 style={{ ...commonStyles.sectionTitle, textAlign: isUrdu ? "right" : "left" }}>{t.contact}</h2>
              <span style={commonStyles.loginLink}>{t.signIn}</span>
            </div>
            <input
              type="text"
              name="emailOrPhone"
              style={{ ...commonStyles.input, textAlign: isUrdu ? "right" : "left" }}
              value={formData.emailOrPhone}
              placeholder={t.emailPhone}
              onChange={handleChange}
              required
            />
            <label style={commonStyles.checkbox}>
              <input
                type="checkbox"
                name="emailNews"
                style={commonStyles.checkboxInput}
                checked={formData.emailNews}
                onChange={handleChange}
              />
              <span>{t.emailNews}</span>
            </label>
          </div>

          {/* 2. Delivery Section */}
          <div style={{ ...commonStyles.section, textAlign: isUrdu ? "right" : "left" }}>
            <h2 style={{ ...commonStyles.sectionTitle, textAlign: isUrdu ? "right" : "left" }}>{t.delivery}</h2>
            
            <select
              name="cityDropdown"
              style={{ ...commonStyles.input, ...(formData.cityDropdown === "" ? commonStyles.inputError : {}), textAlign: isUrdu ? "right" : "left" }}
              value={formData.cityDropdown}
              onChange={handleChange}
              required
            >
              <option value="">{t.selectCity}</option>
              <option value="Lahore">Lahore</option>
              <option value="Karachi">Karachi</option>
              <option value="Islamabad">Islamabad</option>
            </select>
            {formData.cityDropdown === "" && (
              <small style={commonStyles.errorText}>{t.cityErrorDropdown}</small>
            )}

            <select
              name="country"
              style={{ ...commonStyles.input, textAlign: isUrdu ? "right" : "left" }}
              value={formData.country}
              onChange={handleChange}
            >
              <option value="Pakistan">{t.pakistan}</option>
            </select>

            <div style={commonStyles.rowInputs}>
              <input
                type="text"
                name="firstName"
                placeholder={t.firstName}
                style={{ ...commonStyles.input, ...commonStyles.rowInput, textAlign: isUrdu ? "right" : "left" }}
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder={t.lastName}
                style={{ ...commonStyles.input, ...commonStyles.rowInput, textAlign: isUrdu ? "right" : "left" }}
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>

            <input
              type="text"
              name="address"
              placeholder={t.address}
              style={{ ...commonStyles.input, textAlign: isUrdu ? "right" : "left" }}
              value={formData.address}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="apartment"
              placeholder={t.apartment}
              style={{ ...commonStyles.input, textAlign: isUrdu ? "right" : "left" }}
              value={formData.apartment}
              onChange={handleChange}
            />

            <div style={commonStyles.rowInputs}>
              <div style={commonStyles.rowInput}>
                <input
                  type="text"
                  name="cityInput"
                  placeholder={t.city}
                  style={{ ...commonStyles.input, ...(formData.cityInput === "" ? commonStyles.inputError : {}), textAlign: isUrdu ? "right" : "left" }}
                  value={formData.cityInput}
                  onChange={handleChange}
                  required
                />
                {formData.cityInput === "" && (
                  <small style={commonStyles.errorText}>{t.cityErrorInput}</small>
                )}
              </div>
              <input
                type="text"
                name="postalCode"
                placeholder={t.postalCode}
                style={{ ...commonStyles.input, ...commonStyles.rowInput, textAlign: isUrdu ? "right" : "left" }}
                value={formData.postalCode}
                onChange={handleChange}
              />
            </div>

            <input
              type="text"
              name="phone"
              placeholder={t.phone}
              style={{ ...commonStyles.input, textAlign: isUrdu ? "right" : "left" }}
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <label style={commonStyles.checkbox}>
              <input
                type="checkbox"
                name="saveInfo"
                style={commonStyles.checkboxInput}
                checked={formData.saveInfo}
                onChange={handleChange}
              />
              <span>{t.saveInfo}</span>
            </label>
          </div>

          {/* 3. Shipping Method */}
          <div style={{ ...commonStyles.section, textAlign: isUrdu ? "right" : "left" }}>
            <h2 style={{ ...commonStyles.sectionTitle, textAlign: isUrdu ? "right" : "left" }}>{t.shipping}</h2>
            <div style={commonStyles.shippingBox}>
              <span>{t.homeDelivery}</span>
              <strong style={{ color: "#28a745" }}>{t.free}</strong>
            </div>
          </div>

          {/* 4. Payment Section */}
          <div style={{ ...commonStyles.section, textAlign: isUrdu ? "right" : "left" }}>
            <h2 style={{ ...commonStyles.sectionTitle, textAlign: isUrdu ? "right" : "left" }}>{t.payment}</h2>
            <p style={commonStyles.secureText}>{t.secure}</p>
            
            <div style={{ ...commonStyles.paymentOption, ...(formData.paymentMethod === "PAYFAST" ? commonStyles.paymentOptionActive : {}) }}>
              <label style={commonStyles.paymentLabel}>
                <input
                  type="radio"
                  name="paymentMethod"
                  value="PAYFAST"
                  style={commonStyles.paymentRadio}
                  checked={formData.paymentMethod === "PAYFAST"}
                  onChange={handleChange}
                />
                <span>{t.payfast}</span>
              </label>
              {formData.paymentMethod === "PAYFAST" && (
                <div style={{ ...commonStyles.paymentDesc, ...(isUrdu ? { paddingRight: "24px", paddingLeft: "0" } : {}) }}>
                  {t.redirected}
                </div>
              )}
            </div>

            <div style={{ ...commonStyles.paymentOption, ...(formData.paymentMethod === "COD" ? commonStyles.paymentOptionActive : {}) }}>
              <label style={commonStyles.paymentLabel}>
                <input
                  type="radio"
                  name="paymentMethod"
                  value="COD"
                  style={commonStyles.paymentRadio}
                  checked={formData.paymentMethod === "COD"}
                  onChange={handleChange}
                />
                <span>{t.cod}</span>
              </label>
            </div>
          </div>

          {/* 5. Billing Address */}
          <div style={{ ...commonStyles.section, textAlign: isUrdu ? "right" : "left" }}>
            <h2 style={{ ...commonStyles.sectionTitle, textAlign: isUrdu ? "right" : "left" }}>{t.billing}</h2>
            <div style={{ ...commonStyles.paymentOption, ...(formData.billingAddress === "same" ? commonStyles.paymentOptionActive : {}) }}>
              <label style={commonStyles.paymentLabel}>
                <input
                  type="radio"
                  name="billingAddress"
                  value="same"
                  style={commonStyles.paymentRadio}
                  checked={formData.billingAddress === "same"}
                  onChange={handleChange}
                />
                <span>{t.sameAddress}</span>
              </label>
            </div>
            <div style={{ ...commonStyles.paymentOption, ...(formData.billingAddress === "different" ? commonStyles.paymentOptionActive : {}) }}>
              <label style={commonStyles.paymentLabel}>
                <input
                  type="radio"
                  name="billingAddress"
                  value="different"
                  style={commonStyles.paymentRadio}
                  checked={formData.billingAddress === "different"}
                  onChange={handleChange}
                />
                <span>{t.differentAddress}</span>
              </label>
            </div>
          </div>

          <button 
            type="submit" 
            style={commonStyles.submitBtn}
            onMouseEnter={(e) => e.target.style.background =  "#256628"}
            onMouseLeave={(e) => e.target.style.background =  "#256628"}
          >
            {formData.paymentMethod === "COD" ? t.completeOrder : t.payNow}
          </button>

        </form>
      </div>

      {/* RIGHT COLUMN: ORDER SUMMARY - Always stays on right */}
      <div style={commonStyles.rightColumn}>
        <div style={{ ...commonStyles.summary, textAlign: isUrdu ? "right" : "left" }}>
          <h2 style={{ ...commonStyles.summaryTitle, textAlign: isUrdu ? "right" : "left" }}>{t.orderSummary}</h2>
          
          <div>
   {/* {cart.map((item, index) => {
  const price = Number(
    item.price ??
    item.mrp ??
    item.new_price ??
    item.sale_price ??
    0
  );

  const qty = Number(item.qty ?? 1);

  return (
    <div  key={item.id || index}>

      <div style={commonStyles.itemLeft}>
    <img
  src={item.img || item.image}
  alt={item.name}
  style={commonStyles.itemImg}
/>

        <div style={commonStyles.itemDetails}>
          <h4 style={commonStyles.itemName}>{item.name}</h4>
          <p style={commonStyles.itemSize}>
            {t.standardSize}
          </p>
        </div>
      </div>

      <div style={commonStyles.itemPrice}>
        {t.currency} {(price * qty).toLocaleString()}.00
      </div>

    </div>
  );
})} */}
{cart.map((item, index) => {
  const price = Number(
    item.price ??
    item.mrp ??
    item.new_price ??
    item.sale_price ??
    0
  );

  const qty = Number(item.qty ?? 1);

  return (
    <div key={item.id || index} style={styles.productRow}>

      {/* Left Side */}
      <div style={styles.productLeft}>
  <img
 src={getImage(item)}
 alt={item.name}
 style={styles.productImage}
 onError={(e)=>{
   e.target.src="/no-image.png";
 }}
/>

        <div>
          <h4 style={styles.productName}>{item.name}</h4>
          <p style={styles.productSize}>{t.standardSize}</p>
        </div>
      </div>

      {/* Right Side Price */}
      <div style={styles.productPrice}>
        {t.currency} {(price * qty).toLocaleString()}.00
      </div>

    </div>
  );
})}
          </div>

          <div style={commonStyles.discountSection}>
            <input
              type="text"
              placeholder={t.discountCode}
              value={discountCode}
              onChange={(e) => setDiscountCode(e.target.value)}
              style={{ ...commonStyles.discountInput, textAlign: isUrdu ? "right" : "left" }}
            />
            <button 
              type="button" 
              style={commonStyles.discountBtn}
              onClick={handleApplyDiscount}
              onMouseEnter={(e) => e.target.style.background = "#256628"}
              onMouseLeave={(e) => e.target.style.background = "#256628"}
            >
              {t.apply}
            </button>
          </div>
          
          {message && (
            <p style={{ ...commonStyles.message, color: discount > 0 ? "green" : "red", textAlign: isUrdu ? "right" : "left" }}>
              {message}
            </p>
          )}

          <div style={commonStyles.totals}>
            <div style={commonStyles.totalRow}>
              <span>{t.subtotal} • {cart.reduce((a, b) => a + b.qty, 0)} {t.items}</span>
              <span>{t.currency} {totalPrice.toLocaleString()}.00</span>
            </div>

            <div style={commonStyles.totalRow}>
              <span>{t.discount}</span>
              <span style={{ color: discount > 0 ? "#256628" : "#666" }}>
                {discount > 0 ? `- ${discount}%` : "0%"}
              </span>
            </div>

            <div style={commonStyles.totalRow}>
              <span>{t.shipping}</span>
              <span style={{ color: "#256628" }}>{t.free}</span>
            </div>

            <hr style={commonStyles.hr} />

            <div style={{ ...commonStyles.totalRow, ...commonStyles.totalGrand }}>
              <span>{t.total}</span>
              <strong>{t.currency} {discountedTotal.toLocaleString()}.00</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}